import { API_USER } from '../config';
import { sendRequest } from '../send_request';
//
// User unblocks other user
//
export const userUnblockRequest = async (userId) => await sendRequest(API_USER.UNBLOCK_USER_URL(userId), 'DELETE', null);